import React, {useEffect, useState, useCallback, memo} from "react";
import { useNavigate } from 'react-router-dom';
import { useUserContext } from "../../context/User";

import {ThemeProvider, AppBar, Container, Toolbar, Typography, IconButton, Avatar, Tooltip, Menu, MenuItem, Box, CircularProgress } from '@mui/material';
import {ThemeCustom} from '../../styles/Theme';
import './nav_bar.scss';
import ModalLogout from "../Modal/Modal_logout";

import { useCreditData } from "../../hooks/useCredit";
import { useAlertContext } from "../../context/Alerts";

import LogoutIcon from '../../assets/logout.svg'
import EmailAutoIcon from '../../assets/envelope-robot.svg'

import Logo from '../../assets/Logo-rebrand.png'
import CreditIcon from '../../assets/credit.svg'

const NavItems = [
                    {'name':'Email Automation', 'path':'/email-automation', 'icon': EmailAutoIcon},
                    {'name':'Logout', 'path':'/', 'icon': LogoutIcon},
                ];

const NavBar = (props) => {

    const [anchorElUser, setAnchorElUser] = useState(null);
    const [openLogout, setOpenLogout] = useState(false)
    const { userDetails } = useUserContext();
    const { creditResponse, error, loading } = useCreditData()
    const [creditScore, setCreditScore] = useState(0)
    const { sucessAlert, failAlert } = useAlertContext();
    const navigate = useNavigate();

    useEffect(()=>{console.log('userDetails > ', userDetails)},[userDetails])

    const handleOpenUserMenu = useCallback((e) => {
        setAnchorElUser(e.currentTarget);
        console.log('nav bar', e.currentTarget)

    }, []);

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const navItemClick = useCallback((navigateTo, index) => {
        handleCloseUserMenu();
        if(index === NavItems.length - 1) {

            setOpenLogout(true)
        }
        else{
            navigate(navigateTo);
        }
    }, [handleCloseUserMenu, navigate]);

    //credit count

    useEffect(() => {

        if (creditResponse) {
            console.log('creditResponse', creditResponse)
            if (creditResponse.code === 200) {

                const remainingCredit = creditResponse.data.eligibleCvCount - creditResponse.data.processedCvCount;
                setCreditScore(remainingCredit < 0 ? 0 : remainingCredit);
                console.log('remainingCredit', remainingCredit)

            } else if (creditResponse.code !== 204) {

                failAlert(true, creditResponse.message);

            }
        }

    }, [creditResponse]);

    return(
        <ThemeProvider theme={ThemeCustom}>
            <ModalLogout
                openLogout={openLogout}
                setOpenLogout={setOpenLogout}
            />
            <AppBar position="fixed" className="shadow-none">
                <Container maxWidth="xl">
                    <Toolbar disableGutters className="flex justify-between items-center py-5">
                        {/* <div className="text-secondary font-sans font-bold text-3xl cursor-pointer" onClick={()=>navigate('/')}>TalentScout</div> */}
                        <img src={Logo} alt="TalentScout logo" className="w-full max-w-[15rem] cursor-pointer" onClick={()=>navigate('/job-board')}/>
                        <Box>
                            <div className='flex items-center'>
                                <Tooltip title="Remaining Credits">
                                    <div className="flex items-center cursor-default">
                                        <div className="bg-secondary mr-4 rounded-full w-10 h-10 flex items-center justify-center">
                                            <img src={CreditIcon} alt="credit icon" className="w-7 h-"/>
                                        </div>
                                        <Typography component='div' variant="text20" className="min-w-[3.25rem] text-primary font-semibold">{creditScore || 0}</Typography>
                                    </div>
                                </Tooltip>
                                <Typography component='div' variant="text20" className="mx-4 text-cultured">|</Typography>
                                <Box onClick={handleOpenUserMenu} className='flex items-center cursor-pointer'>
                                    <Typography component='div' variant="text20" className="mr-4">{userDetails && userDetails.fullName ? userDetails.fullName : 'User'}</Typography>   
                                    <Tooltip title="Senesh Abeysekara">
                                        <IconButton sx={{ p: 0 }}>
                                            <Avatar alt={userDetails && userDetails.fullName ? userDetails.fullName : 'User'} src="/static/images/avatar/2.jpg" className="bg-primary"/>
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </div>
                            <Menu
                                sx={{ mt: '2.8rem'}}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >  
                            {userDetails ? (
                                <div>
                                    <Typography textAlign="center" component={'div'} className={'menuItem menu-details'}>{userDetails ? userDetails.email : '' }</Typography>
                                    <Typography textAlign="center" component={'div'} className={'menuItem menu-details menu-org'}>{userDetails ? userDetails.companyName : '' }</Typography>
                                </div>):
                                null
                            }
                            {NavItems.map((item, index) => (
                                <MenuItem key={index} onClick={()=>navItemClick(item.path, index)}>
                                    <Typography textAlign="center" component={'div'} className={'menuItem'}>
                                        <img src={item.icon} alt={item.name} className="menuItem_img" width={24}/> {item.name}
                                    </Typography>
                                </MenuItem>
                            ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </ThemeProvider>
    )
}

export default memo(NavBar);